<div
  #contentElRef
  class="content"
>
  <ng-content select="[better-drawer-content]"></ng-content>
</div>

@if (isOpen() && isOver()) {
  <div
    (click)="close()"
    @fade
    class="backdrop"
  ></div>
}

<div
  swipeGesture
  (swiperight)="IS_TOUCH_PRIMARY && close()"
  [style]="sideStyle()"
  class="side"
  (transitionend)="updateStyleAfterTransition()"
>
  <button
    (click)="close()"
    class="close-btn"
  >
    &times;
  </button>
  <div class="side-inner">
    <ng-content select="[better-drawer-side]"></ng-content>
  </div>
</div>
